import React from "react";
import ArrowIcon from "../../shared/arrow";
import PropTypes from "prop-types";

import styles from "./styles.css";
import Accordion from "../../shared/accordion";
import { ANGLE } from "../../../constants/app-constants";
import H2 from "../h2/component";

// const defaultFaq = [
//     {
//         question: "How do I buy a car?",
//         text1: "At CARS24 we have a completely online buying experience. \n\n After finding the car you like, click “Get Started” and you’ll enter our online checkout. Here you will be able to trade-in your old car (if you want to), and be able to pay for your new car outright or apply for finance. \n\n You will generally need to pay a deposit first to purchase your car, which can be done via debit / credit card, POLi, and Apple or Google Pay. If you have paid a deposit, you will be required to pay the remaining balance before we will deliver the car. Registration transfer will also occur after pull payment is received."
//     },
//     {
//         question: "Is registration included in the price?",
//         text1: "Yes. Registration and Complusary Third Party (CTP) insurance are included in the Drive Away Price (DAP). The amount of registration included differs by State, but will be a minimum of 3 months."
//     },
//     {
//         question: "Are prices negotiable?",
//         text1: "No. We’ve priced our cars competitively and fairly for their condition and quality. In fact, the majority of the cars we sell are priced below the market average.\n\nWe also understand negotiating can be a stressful process for buyers, so we believe in no haggle - no hassle to make your next car purchase as stress-free as possible."
//     },
//     {
//         question: "Can I inspect the car before buying?",
//         text1: "While you can’t physically see the car before buying, you can inspect it online. All cars we sell can be seen in a 360º view, inside and out, allowing you to check the car from every angle. We also show photos of any damage and imperfections that may exist."
//     },
//     {
//         question: "Are test drives available?",
//         text1: "Is a 20 minute test drive available? No. a 7 day test drive is available! We believe you only really get a feel of a car after driving it consistently, which is why we offer a 7 day money back return policy which you can use to test drive the car after purchasing. If you’re not happy, for any reason, we’ll give you a 100% refund."
//     }
// ];

const testDriveFaq = [
    {
        question: "How do I buy a car?",
        text1: "At CARS24, we offer both online purchasing and test drive. Test drive is only available for selective cars on our platform. Once you've found the car you love, you can initiate the booking process, which will be coordinated after booking slots for test drive. Additionally, you have the option to trade in your old car if you wish. Payment for your new car can be made outright with cash or through financing.\n\nTo secure your chosen car, you can pay a deposit using either your debit/credit card or through a bank transfer. After the deposit is received, you'll need to settle the remaining balance before we deliver the car. The registration transfer will be completed after the full payment is received."
    },
    {
        question: "Is registration included in the price?",
        text1: "Yes. Registration and Complusary Third Party (CTP) insurance are included in the Drive Away Price (DAP). The amount of registration included differs by State, but will be a minimum of 3 months."
    },
    {
        question: "Are prices negotiable?",
        text1: "No. We’ve priced our cars competitively and fairly for their condition and quality. In fact, the majority of the cars we sell are priced below the market average.\n\nWe also understand negotiating can be a stressful process for buyers, so we believe in no haggle - no hassle to make your next car purchase as stress-free as possible."
    },
    {
        question: "Can I inspect the car before buying?",
        text1: "For selective cars on our platform we provide test drives at our hub. You can choose a preferred slot on the website to schedule a visit to our hub to physically inspect the car. For cars in other states, you can view the car online. All cars we sell can be seen in a 360° view, inside and out, allowing you to check the car from every angle. We also show photos of any damage and imperfections that may exist."
    },
    {
        question: "Are test drives available?",
        text1: "Yes, we offer free test drives for selective cars at our hub. Moreover, we provide a 7-day return policy with a 100% money-back guarantee for all our cars, regardless of their location. This policy allows you to experience the car consistently and, if for any reason you're not satisfied, we'll issue a full refund."
    }
];

const CarDetailsFaq = ({faqRef, faqCdpRevamp}) => {
    const ALLFAQ = testDriveFaq;
    const trackEvent = () => {

    };

    return (
        <div className="container" styleName="styles.wrapper">
            <div styleName={"styles.headingWrapper"}>
                {faqCdpRevamp ? <h3>Frequently Asked Questions</h3> : <H2 text="Frequently Asked Questions" />}
            </div>
            <div className="row" ref={faqRef}>
                <div className="col-12" >
                    {ALLFAQ.map((item, index) =>
                        (
                            <Accordion  key={index} toggleAll={true} totalItems={ALLFAQ.length} collapseAccordion={true}>
                                {({ onClick, currentVisibleStates }) => (
                                    <div styleName={"styles.questionWrapper"}  onClick={() => {
                                        onClick({index});
                                    }}>
                                        <Accordion.Content>
                                            <Accordion.Heading>
                                                <div onClick={() => currentVisibleStates[index] && trackEvent(index, currentVisibleStates[index])} styleName={"styles.questionContainer"}>
                                                    <p styleName={"styles.question"}>{item.question}</p>
                                                    <ArrowIcon black={"BlackArrow"} rotateBy={currentVisibleStates[index] ?  0 : -ANGLE.HUNDRED_EIGHTY } />
                                                </div>
                                            </Accordion.Heading>
                                            <Accordion.Body>
                                                {!currentVisibleStates[index] &&
                                            <p styleName={"styles.answer"}>
                                                {item.text1}
                                                {item.linkText &&  <a href={item.link} target="_blank">{item.linkText}</a>}
                                                {item.text2 || ""}
                                            </p>
                                                }
                                            </Accordion.Body>
                                        </Accordion.Content>
                                    </div>
                                )}

                            </Accordion>)
                    )}
                </div>
            </div>
        </div>
    );
};

CarDetailsFaq.propTypes = {
    faqRef: PropTypes.object,
    faqCdpRevamp: PropTypes.bool
};

export default CarDetailsFaq;
